<div class="actionType-tree" (click)="$event.stopPropagation();">
    <div id="task-type-tree" #TaskTypeTreeMenu></div>
</div>
